<template>
    <div class="account-manage-wrapper">
        <el-row class="order-group-padding">

            <!-- 账号列表-->
            <el-col :span="24" class="order-group-content">
                <el-row class="order-group-title">
                    <h3 style="float:left;" v-if="selectGroup.id > 0">[{{selectGroup.service_name}}]
                        {{selectGroup.name}} ({{selectGroup.id}})</h3>
                    <h3 style="float:left;" v-else>全部</h3>
                </el-row>

                <el-row class="order-info-filter">
                    <el-form :inline="true" ref="searchModel" :model="searchModel">
                        <el-form-item label="用户ID：">
                            <el-input v-model="searchModel.user_id" placeholder="请输入用户ID"></el-input>
                        </el-form-item>
                        <el-form-item label="用户名：">
                            <el-input v-model="searchModel.username" placeholder="请输入用户名"></el-input>
                        </el-form-item>

                        <el-form-item label="真实姓名：">
                            <el-input v-model="searchModel.real_name" placeholder="请输入真实姓名"></el-input>
                        </el-form-item>
                        <el-form-item label="手机号：">
                            <el-input v-model="searchModel.mobile" placeholder="请输入手机号"></el-input>
                        </el-form-item>

                        <el-form-item label="身份" prop="identity">
                            <el-select v-model="searchModel.identity">
                                <el-option
                                        v-for="(identity, key) in identities "
                                        :key="key"
                                        :label="identity"
                                        :value="key"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="是否管理员">
                            <el-select v-model="searchModel.is_admin">
                                <el-option label="全部" value=""></el-option>
                                <el-option label="管理员" value="1"></el-option>
                                <el-option label="非管理员" value="0"></el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="是否公用：">
                            <el-select v-model="searchModel.is_common">
                                <el-option label="全部" value=""></el-option>
                                <el-option label="公用账号" value="1"></el-option>
                                <el-option label="私有账号" value="0"></el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="是否实名：">
                            <el-select v-model="searchModel.is_auth">
                                <el-option label="全部" value=""></el-option>
                                <el-option label="已实名" value="1"></el-option>
                                <el-option label="未实名" value="0"></el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="是否绑定：">
                            <el-select v-model="searchModel.is_bind">
                                <el-option label="全部" value=""></el-option>
                                <el-option label="已绑定" value="1"></el-option>
                                <el-option label="未绑定" value="0"></el-option>
                            </el-select>
                        </el-form-item>


                        <el-form-item>
                            <el-button icon="el-icon-search" type="primary" size="small" @click="submitSearch"> 搜索
                            </el-button>
                            <el-button type="default" size="small" @click="resetSearch"> 重置</el-button>
                            <!-- <el-button size="small" type="success" v-if="Acs('/customer/accounts/export')"
                                       @click="exportAccount">账号导出
                            </el-button> -->
                            <ExportFile 
                            v-if="Acs('/customer/accounts/export')"
                            url="/api/export/customer-accounts" 
                            :params="searchModel" 
                            :filename="customer.name + '-' + '账号表'" 
                            buttonName="账号导出"
                            buttonType="success">
                            </ExportFile>
                        </el-form-item>
                    </el-form>
                </el-row>

                <el-row class="order-group-btn">
                    <el-button size="small" type="primary" @click="showBatchReg = true">批量注册账号</el-button>
                    <el-button size="small" type="primary" @click="showAddExist = true">添加已有账号</el-button>
                    <el-button size="small" type="primary" @click="showRealAuth = true">批量实名&绑定</el-button>
                    <el-tooltip placement="top" effect="light" popper-class="rule-tooltip">
                        <div slot="content">
                            <div style="text-align: left;">
                                <h4>规则介绍：</h4>
                                <ul>
                                    <li>客户内账号与导入账号（真实姓名，手机号一样）一致的，跳过不处理，保留在客户内（<span style="color: #409EFF;">跳过</span>）</li>
                                    <li>客户内账号与导入账号真实姓名一样，手机号不同的，修改手机号（<span style="color: #409EFF;">变更手机号</span>）</li>
                                    <li>客户内账号与导入账号手机号一样，姓名不一样的，修改真实姓名（<span style="color: #409EFF;">变更修改姓名</span>）</li>
                                    <li>客户内账号中真实姓名在导入账号真实姓名中不存在的，删除该账号（<span style="color: #409EFF;">客户内账号移出</span>）</li>
                                    <li>客户内账号中真实姓名与手机号均不存在 但手机号已绑定账号的，会将账号转移进来（<span style="color: #409EFF;">添加/转校</span>）</li>
                                    <li>系统内真实姓名与手机号均不存在的注册新账号（<span style="color: #409EFF;">注册</span>）</li>
                                </ul>
                                <h4>操作流程：</h4>
                                <h5>1.整理导入数据名单：</h5>
                                <ul>
                                    <li>a）检查导入名单的真实姓名/手机号是否为空，存在需删除或填充。</li>
                                    <li>b）检查导入名单的真实姓名/手机号是否存在重复，重复需修改为唯一值。</li>
                                </ul>
                                <h5>2.导出客户内账号名单</h5>
                                <ul>
                                    <li>a）检查账号名单内是否存在真实姓名带数字后缀的账号。</li>
                                </ul>
                                <h5>3.名单比对（没有2的情况时可跳过）</h5>
                                <ul>
                                    <li>b）对比真实姓名，使导入名单的真实姓名与客户内一致（<span style="color: #409EFF;">防止同名教师 账号出错</span>）</li>
                                </ul>
                                <h5>4.客户账号清理</h5>
                                <ul>
                                    <li>a）复制导入名单的 真实姓名 至账户管理的"真实姓名"筛选填充，筛选已存在的账号，对这批账号进行"批量实名&绑定"操作（<span style="color: #409EFF;">避免用户生成多个账号，微信绑定一个，手机绑定一个，存在其他渠道实名不绑定</span>）</li>
                                </ul>
                                <h5>5.导入文件/填写名单</h5>
                                <ul>
                                    <li>a）导入真实姓名+手机号，检查是否存在异常 （<span style="color: #909399;">灰色和黄色标记可忽略</span>）</li>
                                </ul>
                                <h5>6）执行替换/删除</h5>
                                <h5>7）根据导入名单检查账号数量</h5>
                            </div>
                        </div>
                        <el-button size="small" type="danger" @click="showBatchReplace = true">全部删除&替换</el-button>
                    </el-tooltip>
                    <el-button :disabled="disableOptionBtn" size="small" type="primary" @click="showSyncSzxy = true">
                        同步至数字校园
                    </el-button>
                    <el-button :disabled="disableOptionBtn" size="small" type="primary" @click="showBatchPwd = true">
                        批量重置密码
                    </el-button>
                    <el-button :disabled="disableOptionBtn" size="small" type="primary" @click="batchSetAdminAccount">设置管理员</el-button>
                    <el-button v-if="Acs('/customer/accounts/batch-set-public-account')"  :disabled="disableOptionBtn" size="small" type="primary" @click="batchSetPublicAccount">设置公有账号
                    </el-button>
                    <el-button :disabled="disableOptionBtn" size="small" type="warning" @click="batchUnbindMobile">批量解绑手机号</el-button>
                    <el-button :disabled="disableOptionBtn" size="small"  v-if="Acs('/customer/accounts/unbound-wechat-qq-email')" type="warning" @click="dialogFormVisible = true">批量解绑微信/QQ/邮箱</el-button>

                    <el-dialog title="温馨提示" :visible.sync="dialogFormVisible" width="30%" center>
                        <el-form>
                            <span>
                                <i style="float:left;color: #e6a23c; font-size: 25px;margin-right: 5px;" class="el-icon-warning"></i><p>选中的微信/QQ/邮箱 解绑后，对应账号将无法使用微信/QQ/邮箱登陆, 确定要解绑吗？</p>
                            </span>
                            <el-form-item>
                                <el-checkbox v-model="all_unbound">全部</el-checkbox>
                            </el-form-item>
                            <el-form-item>
                                <el-checkbox-group v-model="unbound_list" v-if="!all_unbound">
                                    <el-checkbox label="1">微信</el-checkbox>
                                    <el-checkbox label="2">QQ</el-checkbox>
                                    <el-checkbox label="3">邮箱</el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                        </el-form>
                        <div slot="footer" class="dialog-footer">
                            <el-button @click="dialogFormVisible = false">取 消</el-button>
                            <el-button type="primary" @click="batchUnbindWechatQQEmail" :loading="loading">确 定</el-button>
                        </div>
                    </el-dialog>


                    <el-button :disabled="disableOptionBtn" size="small" type="danger" @click="showDeleteUserDialog = true">删除账号</el-button>

                    <el-button v-if="Acs('/customer/accounts/change-log')" type="text" @click="showLogDialog = true">查看操作日志</el-button>
                </el-row>
                <el-alert
                    title="警告提示"
                    type="warning"
                    description="绑定账号数需与学校规模填写的教师数量一致（注：若绑定账号只有学校的公用账号，可与教师数不一致）"  
                    close-text="朕知道了" 
                    show-icon>
                </el-alert>
                <el-table class="tab-show-data"
                          v-loading="loading"
                          :data="accounts"
                          border
                          style="width: 100%"
                          @selection-change="handleSelectionChange"
                >
                    <el-table-column align="center" prop="user_id" type="selection"></el-table-column>
                    <el-table-column align="center" width="100" prop="user_id" label="用户ID"></el-table-column>
                    <el-table-column align="center" prop="username" label="用户名"></el-table-column>
                    <el-table-column align="center" prop="real_name" label="真实姓名"></el-table-column>
                    <el-table-column align="center" prop="is_common" width="220" label="属性">
                        <template slot-scope="scope">
                            <div>
                                <span v-if="scope.row.is_common" style="color:red;">公有</span>
                                <span v-else>私有</span>
                                <div v-if="scope.row.is_common && scope.row.product_list && scope.row.product_list.length > 0" style="color: #909399; font-size: 12px;">
                                    （<span v-for="(item, index) in scope.row.product_list" :key="index">{{ item.name }}<span v-if="index < scope.row.product_list.length - 1">、</span></span>
                                    <span v-if="scope.row.product_list[0].end_day !== undefined">、{{ scope.row.product_list[0].end_day }}</span>）
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="identity" width="120" label="身份">
                        <template slot-scope="scope">
                            <div>{{scope.row.identity_name}}<span v-if="scope.row.is_admin" style="color:red;">（{{scope.row.is_admin == 1 ? '管理员': ''}}）</span>
                            </div>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column align="center" prop="identity" width="120" label="绑定学科">
                        <template slot-scope="scope">
                         <span v-for=" (item, index) in scope.row.account_subject" :key="index">
                                        <label>{{item}}</label> <br/>
                         </span>
                        </template>
                    </el-table-column> -->

                    <el-table-column align="center" prop="mobile" label="实名手机/绑定手机">
                        <template slot-scope="scope">
                            <div>
                                <span v-if="scope.row.cert_mobile !='' && scope.row.cert_mobile != 0">{{scope.row.cert_mobile}}</span>
                                <span v-else>
                                    <span v-if="scope.row.mobile != '' && scope.row.mobile != 0">{{scope.row.mobile}}</span>
                                    <el-tag v-else type="danger" size="mini">未实名</el-tag>
                                </span>

                                <span v-if="scope.row.mobile != '' && scope.row.mobile != 0">/ {{scope.row.mobile}}</span>
                                <el-tag v-else type="danger" size="mini">未绑定</el-tag>
                                <el-button v-if="scope.row.mobile != '' || scope.row.cert_mobile != ''" type="text" size="mini" icon="el-icon-unlock" @click="unlockMobile(scope.row)">解密</el-button>
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column align="center" prop="nickname" width="200" label="微信/QQ/邮箱解绑">
                      <template slot-scope="scope">
                        <span v-if="scope.row.nickname !=null">{{scope.row.nickname}}<br></span>
                        <el-tag v-else type="danger" size="mini">未绑定</el-tag>
                        <span v-if="scope.row.qqnickname !=null">{{scope.row.qqnickname}}<br></span>
                        <el-tag v-else type="danger" size="mini">未绑定</el-tag>
                        <span v-if="scope.row.email != ''">{{scope.row.email}}</span>
                        <el-tag v-else type="danger" size="mini">未绑定</el-tag>
                        <el-button v-if="(scope.row.nickname !=null  || scope.row.qqnickname !=null || scope.row.email != '') && Acs('/customer/accounts/unbound-wechat-qq-email')"  type="text" size="mini"   @click="oneUnbindShow(scope.row)">解绑</el-button>
                      </template>
                    </el-table-column>
                    <el-table-column label="账号来源" prop="source_name"></el-table-column>
                    <el-table-column label="创建时间" prop="created_at"></el-table-column>
                    <el-table-column label="注册时间" prop="register_at"></el-table-column>
                    <el-table-column align="center" label="操作" width="200">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="handleUpdate(scope.row)">编辑</el-button>
                            <el-button type="text" size="small" @click="handleResetPassword(scope.row)">重置密码</el-button>
                            <el-button
                                    v-if="scope.row.mobile !== '' && scope.row.mobile != 0 && Acs('/customer/accounts/unbind')"
                                    type="text" size="small" @click="unbindMobile(scope.row)">解绑手机
                            </el-button>
                            <el-button v-if="Acs('/szxy/login')" type="text" size="small" @click="szxyQuickLogin(scope.row)">模拟登录</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-row v-if="linkPage">
                    <pagination :linkPage="linkPage" :enableEvent="true" :pageSizes="[20,50,100,200,300]" @change="watchPageChange"></pagination>
                </el-row>

            </el-col>

            <!-- 账号列表 EOF -->

        </el-row>

        <!--创建账号组-->
        <add-group-dialog
                :customerId="customerId"
                v-if="showAddGroup"
                :group="groupModel"
                @createGroupCallback="groupCallback"
        >
        </add-group-dialog>
        <!-- 创建账号组 EOF -->

        <!--批量激活/禁用账号-->
        <active-account
                v-if="showActiveAccount"
                @callback="watchActiveAccount"
                :customerId="customerId"
                :scenario="activeScenario"
                :display="showActiveAccount"
                :accounts="selections">
        </active-account>
        <!--批量激活/禁用账号 EOF -->

        <!-- 更新账号-->
        <update-account
                v-if="showUpdateAccount"
                :display="showUpdateAccount"
                :customerId="customerId"
                :account="accountModel"
                @callback="watchUpdateAccount"
        >
        </update-account>
        <!-- 更新账号 EOF -->

        <!-- 添加已有账号 -->
        <add-exist
                v-if="showAddExist"
                :display="showAddExist"
                :customer-id="customerId"
                @callback="watchAddExist"
        ></add-exist>
        <!-- 添加已有账号 EOF -->

        <!--批量注册-->
        <reg-accounts
                v-if="showBatchReg && customer"
                :display="showBatchReg"
                :customer="customer"
                @callback="watchRegAccounts"
        >
        </reg-accounts>
        <!-- 批量注册EOF -->
        
        <!--批量替换-->
        <replace-accounts
                v-if="showBatchReplace && customer"
                :display="showBatchReplace"
                :customer="customer"
                @callback="watchReplaceAccounts"
        >
        </replace-accounts>
        <!-- 批量注册EOF -->

        <!-- 批量实名认证-->
        <branch-real-auth v-if="showRealAuth" :customer-id="customerId" :display="showRealAuth" :accounts="selections"
                          @callback="watchBatchRealAuth"></branch-real-auth>
        <!-- 批量实名认证 EOF-->

        <!-- 批量实名认证-->
        <copy-to-szxy v-if="selections.length > 0 && showSyncSzxy" :customer-id="customerId" :display="showSyncSzxy"
                      :accounts="selections" @callback="watchSyncSzxy"></copy-to-szxy>
        <!-- 批量实名认证 EOF-->

        <!-- 批量重置密码 -->
        <batch-set-pwd v-if="selections.length > 0 && showBatchPwd" :customer-id="customerId" :display="showBatchPwd"
                       :accounts="selections" @callback="watchBatchResetPassword"></batch-set-pwd>
        <!-- 批量重置密码 EOF  -->

        <el-dialog title="提示" :visible.sync="showDeleteUserDialog" width="30%">
            <span>
                <p><i style="color: #F56C6C; font-size: 20px" class="el-icon-warning"></i>  确定要删除选中的账号嘛？删除后与账号关联的所有服务将不可用</p>
            </span>
            <span>
                <el-checkbox v-model="notifyUserToDelete">同时发送短信通知给被删除的账号</el-checkbox>
            </span>

            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="showDeleteUserDialog = false">取 消</el-button>
                <el-button size="mini" type="primary" :loading="deleting" @click="deleteAccount">确 定</el-button>
            </span>
        </el-dialog>
        
        <el-dialog title="温馨提示" :visible.sync="showSetPrivateDialog" width="30%">
            <span>公有状态：</span>

            <el-switch  v-model="is_public_account"
                        active-text="开启"
                        inactive-text="关闭">
            </el-switch>

            <el-row v-if="is_public_account">
                <span>公有账号适用产品：</span><br>
                <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
                <el-checkbox-group v-model="product_ids" @change="handleCheckedProductChange">
                    <el-checkbox v-for="(product, index) in products" :label="product.id" :key="index">{{product.name}}</el-checkbox>
                </el-checkbox-group>
            </el-row>
            <el-row v-if="is_public_account" style="margin-top: 10px;">
                <span>公有账号有效期：</span>
                <el-input-number v-model="trial_days" :min="1" :step="1" placeholder="请输入试用天数"></el-input-number>
            </el-row>
            
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="showSetPrivateDialog = false">取 消</el-button>
                <el-button size="mini" type="primary" :loading="deleting" @click="updatePublicAccount">确 定</el-button>
            </span>
        </el-dialog>

        <account-log v-if="showLogDialog" :customer="customer" :display="showLogDialog" @callback="watchAccountLog"></account-log>
        <el-dialog title="温馨提示" :visible.sync="showSetAdminDialog" width="30%">
            <span>设置管理员：</span>
            <el-switch  v-model="is_admin_account"
                        active-text="开启"
                        inactive-text="关闭">
            </el-switch>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="showSetAdminDialog = false">取 消</el-button>
                <el-button size="mini" type="primary" :loading="deleting" @click="batchSetAdmin">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>

    import Pagination from "~/widgets/Pagination.vue";
    import AccountService from "~/services/CustomerAccounts";
    import AddGroupDialog from "./dialog/addGroupDialog.vue";
    import ActiveAccount from "./dialog/ActiveAccount.vue";
    import UpdateAccount from "./dialog/UpdateAccount.vue";
    import RegAccounts from "./dialog/RegAccounts.vue";
    import AddExist from "./dialog/AddExist.vue";
    import BranchRealAuth from "./dialog/BranchRealAuth.vue";
    import CopyToSzxy from "./dialog/CopyToSzxy.vue";
    import BatchSetPwd from "./dialog/BatchSetPwd.vue";
    import Function from "~/common/functions";
    import AccountLog from "./dialog/AccountLog.vue";
    import ReplaceAccounts from "./dialog/ReplaceAccounts.vue";
    import ExportFile from "~/widgets/ExportFile.vue";

    export default {
        name: "CustomerAccount",
        components: {
            CopyToSzxy,
            Pagination,
            AddGroupDialog,
            ActiveAccount,
            UpdateAccount,
            RegAccounts,
            AddExist,
            BranchRealAuth,
            BatchSetPwd,
            AccountLog,
            ReplaceAccounts,
            ExportFile
        },
        props: {

            customer: {
                type: Object,
                default: null,
                required: true
            }
        },
        data() {
            return {
                customerId: 0,
                defaultGroup: "0",
                groups: [],
                accountLength: 0,

                // 被选中的组
                selectGroup: {},
                showAddGroup: false,
                groupModel: null,
                is_public_account:false,
                is_admin_account: false,
                // 账号列表数据容器
                accounts: [],
                linkPage: null,
                accountModel: null,

                // 列表选中数据容器
                selections: [],
                // 是否禁用操作按钮，它的值依赖 selections 中是否有被选中的记录
                disableOptionBtn: true,
                // 批量激活账号的场景值用于判断是激活还是禁用账号
                activeScenario: 'active',
                showActiveAccount: false,

                // 搜索列表模型
                searchModel: null,
                identities: AccountService.getIndentify(),

                showUpdateAccount: false,
                showSetPrivateDialog: false,

                showSetAdminDialog: false,
                customerPrefix: '',

                // 是否显示批量注册窗口
                showBatchReg: false,
                // 是否显示批量替换窗口
                showBatchReplace: false,
                // 是否显示添加已有账号窗口
                showAddExist: false,
                // 是否显示批量实名&绑定窗口
                showRealAuth: false,

                // 是否显示同步至数字化校园窗口
                showSyncSzxy: false,

                showBatchPwd: false,

                // 显示确认删除dialog
                showDeleteUserDialog: false,

                // 通知用户删除
                notifyUserToDelete: false,
                deleting: false,

                showLogDialog:  false,
                loading: false,
                dialogFormVisible: false,
                unbound_list: [],
                all_unbound: false,
                products: [
                    {name: '二一校网通', id: 2},
                    // {name: '二一组卷', id: 1},
                    {name: '校本资源库', id: 5},
                ],
                checkAll: false,
                product_ids: [],
                isIndeterminate: false,
                trial_days: 10, // 添加账号试用天数属性
            }
        },
        watch: {
            customerId: function (value, original) {
                this.getGroups({customer_id: value});
            },

            selections: function (value, original) {
                if (value.length > 0) {
                    this.disableOptionBtn = false;
                } else {
                    this.disableOptionBtn = true;
                }
            },

            selectGroup: function (value, original) {

                let group_id = '';
                if (value.id && value.id > 0) {
                    group_id = value.id
                }

                this.searchModel.group_id = group_id;
                this.getAccounts(this.searchModel);
            },

        },

        created: function () {

            if (this.customer !== null) {
                this.customerId = this.customer.id;
            }

            this.searchModel = this.getSearchModel();
            this.identities = AccountService.getIndentify();
            //this.getGroups({customer_id: this.customerId});
            this.getAccounts(this.searchModel)
        },

        methods: {

            /**
             * 监听分页改变事件
             * @param pageParams
             */
            watchPageChange(pageParams) {
                this.searchModel['page'] = pageParams["page"];
                this.searchModel['perPage'] = pageParams["perPage"];
                this.getAccounts(this.searchModel);
            },
            updatePublicAccount()
            {
                if (this.trial_days <= 0) {
                    this.$message.error('试用天数必须大于0');
                    return;
                }
                const ids = this.products.map(item => item.id);
                const close_product_ids = ids.filter(id => !this.product_ids.includes(id));
                AccountService.batchSetPublicAccount({
                    accounts: this.selections,
                    is_public_account: this.is_public_account,
                    customer_id: this.customerId,
                    product_ids: close_product_ids,
                    trial_days: this.trial_days // 添加试用天数参数
                }).then(res => {
                    if (res.code == 0) {
                        this.is_public_account = 0;//默认打开是关闭
                        this.trial_days = 10; // 重置试用天数
                        this.showSetPrivateDialog = false;
                        this.$message.success("设置成功!");
                        this.getAccounts(this.searchModel);
                    }
                }).catch(error => {
                    console.error(error);
                })
            },

            getSearchModel() {
                return {
                    customer_id: this.customerId,
                    user_id: '',
                    identity: '',
                    group_id: '',
                    username: '',
                    is_admin: '',
                    is_common: '',
                    service: '',
                    real_name: '',
                    // 是否实名认证
                    is_auth: '',
                    // 是否绑定手机号
                    is_bind: '',
                    page: 1,
                    perPage: 20
                };
            },

            getGroups(params) {
                AccountService.getGroups(params).then(res => {
                    if (res.code == 0 && res.data != null) {
                        this.groups = res.data;
                    }
                }).catch(err => {
                    console.error(err)
                })
            },

            getAccounts(params) {

                if (params.identity && params.identity == 0) {
                    params.identity = '';
                }
                if (params.mobile && params.mobile != '') {
                    params.isMobile = 1;
                }


                this.loading = true;

                AccountService.getAccounts(params).then(res => {
                    if (res.code == 0) {
                        this.accounts = res.data;
                        if (res._meta) {
                            this.linkPage = res._meta;
                        }
                    }
                    this.loading = false;
                }).catch(error => {
                    console.error(error);
                })
            },


            // 创建用户组回调
            groupCallback(isShow) {
                this.showAddGroup = isShow;
                this.getGroups({customer_id: this.customerId});
            },

            // 跟新用户组
            updateGroup(group) {
                this.groupModel = group;
                this.showAddGroup = true;
            },

            deleteGroup(group) {

                this.$confirm("确定要删除该条数据?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    AccountService.deleteGroup(group).then(res => {
                        if (res.code == 0) {

                            this.$message({
                                message: "删除成功!",
                                type: "success"
                            });

                            this.getGroups({customer_id: this.customerId});
                        }
                    });
                }).catch(() => {
                });
            },

            /**
             * 选择左侧账户组触发的事件回调
             * @param group
             */
            selectionGroup(group) {
                this.selectGroup = group;
            },

            selectionAllGroup() {
                this.selectGroup = {};
            },


            /**
             * 处理选中列表数据
             */
            handleSelectionChange(accounts) {
                this.selections = [];
                accounts.forEach(row => {
                    this.selections.push(row.user_id);
                });
            },

            watchActiveAccount(status) {
                this.showActiveAccount = false;
                if (status == true) {
                    this.getAccounts(this.searchModel)
                }
            },

            deleteAccount() {

                if (this.selections.length < 1) {
                    this.$message.error('请先选择要删除的数据');
                    return;
                }

                this.deleting = true;
                AccountService.deleteAccount({
                    customer_id: this.customerId,
                    accounts: this.selections,
                    enable_notify: this.notifyUserToDelete
                }).then(res => {
                    this.showDeleteUserDialog = false;
                    this.deleting = false;
                    if (res.code == 0) {
                        this.$message.success("删除成功!");
                        this.getAccounts(this.searchModel);
                    }
                }).catch(error => {
                    this.showDeleteUserDialog = false;
                    this.deleting = false;
                    console.error(error);
                })


                return true;
            },

            handleResetPassword(account) {
                this.accountModel = {
                    user_id: account.user_id,
                    customer_id: account.customer_id,
                    username: account.username,
                    group_id: '',
                    password: '',
                    real_name: account.real_name,
                    identity: account.identity,
                    is_admin: account.is_admin ? "1" : "0",
                    is_common: account.is_common ? "1" : "0",
                    mobile: account.mobile
                };
                if (!account.mobile) {
                    this.$message.error("此用户未绑定手机号,不能进行重置密码！");
                    return false;
                }
                this.$confirm('此操作会将新密码发送到此用户绑定手机上,确认重置？', '温馨提示', {type: "warning"}).then(() => {
                        AccountService.resetPasswordSms(this.accountModel).then(res => {
                            if (res.code == 0) {
                                this.$message({
                                    message: "密码重置成功,密码已发生至绑定手机：【" + account.mobile + "]上,请注意查收",
                                    type: "success",
                                    showClose: true,
                                });
                            } else {
                                this.$message.error(res.msg);
                                return false;
                            }
                        })
                    }
                );
            },

            handleUpdate(account) {
                const ids = this.products.map(item => item.id);
                const close_product_ids = account.closeProducts && account.closeProducts.length > 0 ? account.closeProducts.map(item => parseInt(item.product_id)) : [];
                const product_ids = ids.filter(id => !close_product_ids.includes(id));

                this.accountModel = {
                    user_id: account.user_id,
                    customer_id: account.customer_id,
                    username: account.username,
                    group_id: '',
                    password: '',
                    real_name: account.real_name,
                    identity: account.identity,
                    is_admin: account.is_admin ? "1" : "0",
                    is_common: account.is_common ? 1 : 0,
                    mobile: account.mobile != 0 ? account.mobile : '',
                    product_ids: product_ids
                };

                this.showUpdateAccount = true;
            },

            watchUpdateAccount(status) {
                this.showUpdateAccount = false;
                this.accountModel = null;
                if (status == true) {
                    this.getAccounts(this.searchModel);
                }
            },

            /**
             * 提交搜索请求
             */
            submitSearch() {
                this.getAccounts(this.searchModel);
            },

            resetSearch() {
                this.searchModel = this.getSearchModel();
                this.getAccounts(this.searchModel);
            },

            /**
             * 监听批量注册回调
             * @param status
             */
            watchRegAccounts(status) {
                this.showBatchReg = false;
                if (status == true) {
                    this.getAccounts(this.searchModel);
                }
            },

            /**
             * 监听批量替换回调
             * @param status
             */
             watchReplaceAccounts(status) {
                this.showBatchReplace = false;
                if (status == true) {
                    this.getAccounts(this.searchModel);
                }
            },

            watchAddExist(status) {
                this.showAddExist = false;
                if (status == true) {
                    this.getAccounts(this.searchModel);
                }
            },

            // 导出账号
            exportAccount() {
                let url = 'https://scrm.21cnjy.net/customer/accounts/export';
                Function.exportFile(url, this.searchModel);
                return false;
            },

            /**
             * 监听批量验证&绑定处理结果
             * @param status
             */
            watchBatchRealAuth(status) {
                this.showRealAuth = false;
                if (status == true) {
                    this.getAccounts(this.searchModel);
                }
            },

            /**
             * 监听同步数字校园处理结果
             * @param status
             */
            watchSyncSzxy(status) {
                this.showSyncSzxy = false;
                if (status == true) {
                    this.getAccounts(this.searchModel);
                }
            },

            /**
             * 监听批量重置密码结果
             * @param status
             */
            watchBatchResetPassword(status) {
                this.showBatchPwd = false;
                if (status == true) {
                    this.getAccounts(this.searchModel);
                }
            },

            batchSetAdmin() {
                if (this.selections.length < 1) {
                    this.$message.error('请先选择要要设为管理员的数据');
                    return;
                }
                AccountService.batchSetAdmin({
                    customer_id: this.customerId,
                    is_admin_account: this.is_admin_account,
                    accounts: this.selections
                }).then(res => {
                    if (res.code == 0) {
                        this.is_admin_account = 0;
                        this.showSetAdminDialog = false;
                        this.$message.success("设置成功!");
                        this.getAccounts(this.searchModel);
                    }
                }).catch(error => {
                    console.error(error);
                })
            },
            batchSetPublicAccount() {
                this.showSetPrivateDialog = true;
            },
            batchSetAdminAccount() {
                this.showSetAdminDialog = true;
            },
            batchUnbindMobile() {

                this.$confirm("选中的手机号解绑后，对应账号将无法正常登录使用, 确定要解绑吗？", "温馨提示", {type: "warning"}).then(ok => {

                    if (this.selections.length < 1) {
                        this.$message.error('请先选择要要设为管理员的数据');
                        return;
                    }

                    AccountService.unbind({
                        customer_id: this.customerId,
                        accounts: this.selections
                    }).then(res => {
                        if (res.code == 0) {
                            this.$message.success("解绑成功！");
                            this.getAccounts(this.searchModel);
                        }
                    }).then(err => {
                        console.error(err);
                    });

                    return true;
                }).catch(cancel => {
                    return false;
                });

                return false;
            },
            batchUnbindWechatQQEmail() {
                var unbound_type_list = this.unbound_list;
                if(this.all_unbound){
                    unbound_type_list = ['1', '2', '3'];
                }else{
                    if(unbound_type_list.length == 0){
                        this.$message.error("请勾选解绑方式");
                        return false;
                    }
                }
                this.loading = true;
                AccountService.unbindWechatQQEmail({
                    customer_id: this.customerId,
                    accounts: this.selections,
                    unbound_list: unbound_type_list,
                }).then(res => {
                    if (res.code == 0) {
                    this.$message.success("解绑成功！");
                    this.getAccounts(this.searchModel);
                    }else{
                        this.$message.error(res.msg);
                    }
                    this.dialogFormVisible = false;
                    this.loading = false;
                }).then(err => {
                    console.error(err);
                    this.dialogFormVisible = false;
                    this.loading = false;
                });
            },

            /**
             * 解绑账号手机号）
             * @param account
             * @returns {boolean}
             */
            unbindMobile(account) {

                this.$confirm("手机号解绑后，该账号将无法正常登录使用, 确定要解绑吗？", "温馨提示", {type: "warning"}).then(ok => {

                    if (account.mobile == "" || account.mobile == 0) {
                        this.$message.error("别闹，从来就没绑定过何来解绑一说？")
                        return false;
                    }

                    AccountService.unbind({
                        customer_id: account.customer_id,
                        accounts: [account.user_id]
                    }).then(res => {
                        if (res.code == 0) {
                            this.$message.success("解绑成功！");
                            this.getAccounts(this.searchModel);
                        }
                    }).then(err => {
                        console.error(err);
                    });

                    return true;
                }).catch(cancel => {
                    return false;
                });

                return false;
            },

            watchAccountLog(cb, status) {
                this.showLogDialog = status;
            },

            unlockMobile(account) {
                AccountService.getInfo({
                    customer_id: account.customer_id,
                    user_id: account.user_id
                }).then(res => {
                    if (res.code == 0) {
                        this.$message.success("解密成功！");
                        account.mobile = res.data.mobile;
                        account.cert_mobile = res.data.cert_mobile;
                    }
                }).then(err => {
                    console.error(err);
                });
            },
            oneUnbindShow(account){
                this.selections = [account.user_id];
                this.dialogFormVisible = true;
            },

            szxyQuickLogin(row) {
                AccountService.szxyQuickLogin({
                    customer_id: row.customer_id,
                    user_id: row.user_id
                }).then(res => {
                    if (res.code == 0) {
                        window.open(res.data, '_blank');
                    }
                })
            },


            handleCheckAllChange(val) {
                const ids = this.products.map(item => item.id);
                this.product_ids = val ? ids : [];
                this.isIndeterminate = false;
            },

            handleCheckedProductChange(value) {
                let checkedCount = value.length;
                this.checkAll = checkedCount === this.products.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.products.length;
            }
        },


    }
</script>

<style>
.rule-tooltip .el-tooltip__popper {
    max-width: 600px;
    line-height: 1.5;
}
.rule-tooltip h4 {
    margin: 10px 0 5px 0;
    font-weight: bold;
}
.rule-tooltip h5 {
    margin: 8px 0 3px 0;
    font-weight: bold;
}
.rule-tooltip ul {
    margin: 5px 0;
    padding-left: 20px;
}
.rule-tooltip li {
    margin-bottom: 3px;
}
</style>



// WEBPACK FOOTER //
// src/views/customer/Account.vue